import { ExternalLink, Star, Shield } from 'lucide-react';
import { SiUpwork } from 'react-icons/si';
import clutchLogo from '@/assets/clutch-logo.png';
import goodFirmsLogo from '@/assets/goodfirms-logo.png';
import techBehemothsLogo from '@/assets/techbehemoths-v2.png';

const platforms = [
  {
    name: "Upwork",
    rating: "100% Job Success",
    badge: "Top Rated Plus",
    url: "https://www.upwork.com/freelancers/praveenjha",
    icon: SiUpwork,
    image: null,
    iconColor: "#6FDA44",
    bgColor: "bg-green-50 dark:bg-green-950/30",
    textColor: "text-green-700 dark:text-green-400"
  },
  {
    name: "Clutch",
    rating: "5/5 Stars",
    badge: "Verified Reviews",
    url: "https://clutch.co/profile/ortem-technologies",
    icon: null,
    image: clutchLogo,
    iconColor: "#EF4444",
    bgColor: "bg-red-50 dark:bg-red-950/30",
    textColor: "text-red-700 dark:text-red-400"
  },
  {
    name: "GoodFirms",
    rating: "5/5 Stars",
    badge: "Top Developer",
    url: "https://www.goodfirms.co/company/ortem-technologies-llc",
    icon: null,
    image: goodFirmsLogo,
    iconColor: "#3B82F6",
    bgColor: "bg-blue-50 dark:bg-blue-950/30",
    textColor: "text-blue-700 dark:text-blue-400"
  },
  {
    name: "TechBehemoths",
    rating: "5/5 Stars",
    badge: "Top Web Developer",
    url: "https://techbehemoths.com/company/ortem-technologies-llc",
    icon: null,
    image: techBehemothsLogo,
    iconColor: "#0066FF",
    bgColor: "bg-blue-50/50 dark:bg-blue-900/20",
    textColor: "text-blue-600 dark:text-blue-300"
  }
];

export function PlatformBadges() {
  return (
    <section className="py-16 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-4">
            <Shield className="w-5 h-5 text-primary" />
            <span className="text-primary font-semibold tracking-wider uppercase text-sm">
              Verified Profiles
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Trusted Across Platforms
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Check our verified profiles and reviews on leading B2B platforms
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
          {platforms.map((platform) => {
            const IconComponent = platform.icon;
            return (
              <a
                key={platform.name}
                href={platform.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group glass-card-hover rounded-2xl p-8 text-center transition-all duration-300"
              >
                {/* Platform Icon/Image */}
                <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-card border-2 border-border
                              flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform overflow-hidden relative">
                  {platform.image ? (
                    <img
                      src={platform.image}
                      alt={`${platform.name} logo`}
                      className="w-full h-full object-contain p-4"
                    />
                  ) : IconComponent ? (
                    <IconComponent
                      aria-hidden="true"
                      className="w-10 h-10"
                      style={{ color: platform.iconColor }}
                    />
                  ) : null}
                </div>

                {/* Platform Name */}
                <h3 className="text-xl font-bold text-foreground mb-2 group-hover:text-primary transition-colors">
                  {platform.name}
                </h3>

                {/* Rating */}
                <div className="flex items-center justify-center gap-1 mb-3">
                  <Star className="w-4 h-4 text-yellow-500 fill-yellow-500" />
                  <span className="text-foreground font-semibold">{platform.rating}</span>
                </div>

                {/* Badge */}
                <span className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-sm font-medium ${platform.bgColor} ${platform.textColor}`}>
                  <Shield className="w-3 h-3" />
                  {platform.badge}
                </span>

                {/* View Link */}
                <div className="mt-6 flex items-center justify-center gap-2 text-primary opacity-0 group-hover:opacity-100 transition-opacity">
                  <span className="text-sm font-medium">View Profile</span>
                  <ExternalLink className="w-4 h-4" />
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
